module.exports = __webpack_public_path__ + "img/double-file.8f9baefc.svg";